import { useEffect, useRef, useState } from 'react';

import { useAppliedTheme } from '@xing-com/hub';

import { Styled } from './styles';

type ArticleCoverImageProps = {
  coverImageURL?: string;
  caption?: string;
};

const ArticleCoverImage: React.FC<ArticleCoverImageProps> = ({
  coverImageURL,
  caption,
}) => {
  const imageRef = useRef<HTMLImageElement>(null);
  const currentTheme = useAppliedTheme();
  const isDarkMode = currentTheme === 'dark';
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (!loaded && imageRef.current?.complete) {
      setLoaded(true);
    }
  }, [loaded]);

  if (!coverImageURL) {
    return null;
  }

  return (
    <Styled.HeaderImageContainer
      data-qa="article-viewer-cover-image"
      aria-hidden={!caption}
    >
      {!loaded ? <Styled.HeaderImageSkeleton /> : null}
      <img
        ref={imageRef}
        style={!loaded ? { display: 'none' } : {}}
        src={coverImageURL}
        alt=""
        onLoad={() => setLoaded(true)}
      />
      {caption ? (
        <Styled.HeaderImageCaption $isDarkMode={isDarkMode}>
          {caption}
        </Styled.HeaderImageCaption>
      ) : null}
    </Styled.HeaderImageContainer>
  );
};

export default ArticleCoverImage;
